import client from "../api/client";

function readCookie(name) {
  const cookies = String(document.cookie || "").split(/;\s*/);
  const entry = cookies.find((part) => part.startsWith(`${encodeURIComponent(name)}=`));
  return entry ? decodeURIComponent(entry.split("=").slice(1).join("=")) : "";
}

const USER_STORAGE_KEY = "app_user";
const TOKEN_STORAGE_KEY = "app_token";
let authBootstrapPromise = null;
let authResolved = false;

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_STORAGE_KEY) || "null");
  } catch {
    return null;
  }
}

export function getToken() {
  return localStorage.getItem(TOKEN_STORAGE_KEY) || "";
}

export function isAuthenticated() {
  return Boolean(getStoredUser());
}

export function isAuthResolved() {
  return authResolved;
}

export function saveAuthSession({ user, token }) {
  if (user) {
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
  } else {
    localStorage.removeItem(USER_STORAGE_KEY);
  }

  if (token) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } else if (!user) {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  }

  authResolved = true;
  window.dispatchEvent(new Event("auth-changed"));
}

export async function bootstrapAuth() {
  if (authBootstrapPromise) return authBootstrapPromise;

  authBootstrapPromise = (async () => {
    try {
      const { data } = await client.get("/api/v1/auth/me");
      if (data) {
        localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(data));
        authResolved = true;
        window.dispatchEvent(new Event("auth-changed"));
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem(USER_STORAGE_KEY);
        localStorage.removeItem(TOKEN_STORAGE_KEY);
      }
      window.dispatchEvent(new Event("auth-changed"));
    }

    authResolved = true;
    return null;
  })();

  try {
    return await authBootstrapPromise;
  } finally {
    authBootstrapPromise = null;
  }
}

export async function clearAuthSession() {
  try {
    await client.post("/api/v1/auth/logout");
  } catch {}
  localStorage.removeItem(USER_STORAGE_KEY);
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  authResolved = true;
  window.dispatchEvent(new Event("auth-changed"));
}
